import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { CatalogGrade } from "../models/CatalogGrade";

export const getCatalogGrades = async () => {
  const apiService = new MESApiService();

  return await apiService.callV2("[STEEL].[GetGrades]", []);
};
export const upsertCatalogGrade = async (grade: CatalogGrade) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    { name: "Id", value: grade.GradeId },
    { name: "Name", value: grade.GradeName },
    { name: "Author", value: grade.Author },
    { name: "Comments", value: grade.Comments },
    { name: "Enabled", value: grade.Enabled },
  ];

  return await apiService.callV2("[STEEL].[UpsertGrade]", parameters);
};
export const deleteCatalogGrade = async (GradeId: number | null) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [{ name: "GradeId", value: GradeId }];

  return await apiService.callV2("[STEEL].[DeleteGrade]", parameters);
};

type upsertCatGradeChemistryLimitProps = {
  gradeId: number;
  elementId: number;
  minValue?: number | null;
  maxValue?: number | null;
  aimValue?: number | null;
};

export const upsertCatGradeChemistryLimit = async ({
  gradeId,
  elementId,
  minValue,
  maxValue,
  aimValue,
}: upsertCatGradeChemistryLimitProps) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    { name: "GradeId", value: gradeId },
    { name: "ElementId", value: elementId },
    { name: "MinValue", value: minValue ?? null },
    { name: "MaxValue", value: maxValue ?? null },
    { name: "AimValue", value: aimValue ?? null },
  ];

  return await apiService.callV2(
    "[LAB].[UpsertGradeChemistryLimit]",
    parameters,
  );
};

export const copyChemistriesLimit = async ({
  source,
  target,
}: {
  source: number;
  target: number;
}) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    { name: "SourceGradeId", value: source },
    { name: "TargetGradeId", value: target },
  ];

  return await apiService.callV2(
    "[LAB].[CopyGradeChemistryLimits]",
    parameters,
  );
};
export const getCatGradeChemistryLimits = async (gradeId: number) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [{ name: "GradeId", value: gradeId }];

  return await apiService.callV2(
    "[LAB].[GetCatGradeChemistryLimitsDE]",
    parameters,
  );
};
export const deleteGradeChemistryLimit = async (
  gradeId: number,
  elementId: number,
) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    { name: "GradeId", value: gradeId },
    { name: "ElementId", value: elementId },
  ];

  return await apiService.callV2(
    "[LAB].[DeleteGradeChemistryLimit]",
    parameters,
  );
};
